
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import {
  competencyQuestionsOnboardingFormSchema,
  mapCompetencyQuestionsOnboardingFormForBackend,
  mapCompetencyQuestionsOnboardingFormForToFrontend,
} from "./types";
import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Button, Form, FormField, FormLabel, Textarea } from "../ui";
import { ActivityIndicator, View } from "react-native";
import { Recruitment } from "../types/Recruitment";
import { trpc } from "@/trpc/react";
import { router } from "expo-router";
import Toast from "react-native-toast-message";

interface CompetencyQuestionsFormProps {
  recruitmentData: Recruitment
  onFormSuccess: () => void
}

export default function CompetencyQuestionsForm({ recruitmentData, onFormSuccess }: CompetencyQuestionsFormProps) {
  const form = useForm<z.infer<typeof competencyQuestionsOnboardingFormSchema>>({
    resolver: zodResolver(competencyQuestionsOnboardingFormSchema),
    defaultValues: mapCompetencyQuestionsOnboardingFormForToFrontend(recruitmentData)
  });

  const { mutate: updateRecruitment } = trpc.recruitment.update.useMutation({
    onSuccess(_response) {
      onFormSuccess();
      router.back();
      Toast.show({
        type: 'success',
        text1: 'Successfully saved your competency questions'
      });
    },
  });


  async function onSubmit(data: z.infer<typeof competencyQuestionsOnboardingFormSchema>) {
    const mappedDetails = mapCompetencyQuestionsOnboardingFormForBackend(recruitmentData.id, data);
    updateRecruitment(mappedDetails);
  }

  return (
    <Card className='mt-4 mb-20'>
      <CardContent>
        <Form {...form}>
          <View className="gap-4 mt-8">
            <FormField
              control={form.control}
              name="tasks_assigned_description"
              render={({ field }) => (
                <View className='flex-1'>
                  <FormLabel>
                    You have completed all tasks assigned to you by your manager. What would you do next?
                  </FormLabel>
                  <Textarea
                    {...field}
                    onChangeText={(value) => {
                      field.onChange(value);
                    }}
                    value={field.value || ''}
                  />
                </View>
              )}
            />
            <FormField
              control={form.control}
              name="completed_task_description"
              render={({ field }) => (
                <View className='flex-1'>
                  <FormLabel>
                    You have been asked to complete a task by your manager, but you are unsure of how to do it correctly. What would you do?
                  </FormLabel>
                  <Textarea
                    {...field}
                    onChangeText={(value) => {
                      field.onChange(value);
                    }}
                    value={field.value || ''}
                  />
                </View>
              )}
            />
            <FormField
              control={form.control}
              name="dangerous_description"
              render={({ field }) => (
                <View className='flex-1'>
                  <FormLabel>
                    You notice someone working in a dangerous manner on site. What would you do?
                  </FormLabel>
                  <Textarea
                    {...field}
                    onChangeText={(value) => {
                      field.onChange(value);
                    }}
                    value={field.value || ''}
                  />
                </View>
              )}
            />
          </View>
          <Button
            size="default"
            variant="crew"
            onPress={form.handleSubmit(onSubmit)}
            className="mt-4"
          >
            {form.formState.isSubmitting ? (
              <ActivityIndicator size="small" />
            ) : (
              "Save"
            )}
          </Button>
        </Form>
      </CardContent>
    </Card >
  )

}